import { useMutation } from '@tanstack/react-query';
import { postTestGenericQualification as postTestGenericQualificationService } from 'services/api/WorkflowServiceAPI';

export const usePostTestGenericQualification = () => {
    const { mutateAsync: postTestGenericQualification, isPending } = useMutation({
        mutationFn: postTestGenericQualificationService,
        retry: false,
    });

    return { postTestGenericQualification, isPending };
};
